import * as React from 'react';
import { ListBox } from '../ListBox';
import { ListTreeLegend } from '../ListTreeLegend';

import { List, ListItem, TopItem } from './styles';

export const ListTree = props => {
	const getDataChunks = (data, chunkLength) => {
		return data.reduce((acc, item) => {
			if (acc.length === 0) {
				acc.push([]);
			}

			let currentChunk = acc[acc.length - 1];

			if (currentChunk.length === chunkLength) {
				acc.push([]);
			}

			currentChunk = acc[acc.length - 1];

			currentChunk.push(item);

			return acc;
		}, []);
	};

	const {
		data,
		total,
		selectedCompanies,
		colors,
		exportId,
		renderContextualMenu,
	} = props;

	let colsPerRow = 3;

	if (selectedCompanies && selectedCompanies.length > 2) {
		colsPerRow = 2;
	}

	const chunks = getDataChunks(data, colsPerRow);

	return (
		<div id={exportId}>
			<TopItem colsPerRow={colsPerRow}>
				<ListBox
					colors={colors}
					total={total}
					isTopItem
					selectedCompanies={selectedCompanies}
				/>
			</TopItem>
			{chunks.map((chunkOfData, j) => (
				<List
					singleItemList={chunkOfData.length === 1}
					keepConnectorLine={chunks.length === 1}
					pairItemList={chunkOfData.length === 2}
					colsPerRow={colsPerRow}
					key={j}
				>
					{chunkOfData.map((dataItem, i) => (
						<ListItem key={i}>
							<ListBox
								colors={colors}
								total={{
									categoryName: dataItem.categoryName,
									value: dataItem.value,
								}}
								data={dataItem.data}
								selectedCompanies={selectedCompanies}
								renderContextualMenu={renderContextualMenu}
							/>
						</ListItem>
					))}
				</List>
			))}
			{selectedCompanies &&
				selectedCompanies.length > 1 && (
					<ListTreeLegend data={selectedCompanies} colors={colors} />
				)}
		</div>
	);
};
